/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  BACKGROUND,
  BackgroundDefinition,
  IMAGE,
  ImageDefinition,
  VIDEO
} from '../../items';
import { VideoDefinition } from '../../items/video/Video';
import { ItemHelper, ItemOfType } from './types';
import { isIOS, isSafari } from 'react-device-detect';

type BackgroundPic = NonNullable<ItemOfType<'Background'>['pictures']>[0];

const makeImage: (pic: BackgroundPic) => ImageDefinition = ({
  id,
  mediaUrl,
  name,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  backgroundSizeForMobile
}) => {
  let className = 'bgImage';

  if (name && name?.indexOf('#') >= 0) {
    className = 'emptyBgImage';
  }

  return {
    id,
    type: IMAGE,
    values: {
      url: mediaUrl || '',
      alt: name || '',
      backgroundSizeForMobile: backgroundSizeForMobile || undefined,
      className
    },
    items: []
  };
};

type BackgroundVideo = NonNullable<ItemOfType<'Background'>['videos']>[0];
const makeVideo: (vid: BackgroundVideo) => VideoDefinition = ({
  id,
  autoPlay,
  mediaUrl,
  subtitlesUrl,
  snapshotUrl,
  mpegDashUrl,
  hlsUrl
}) => {
  const mediaUrlData =
    isIOS || isSafari
      ? ([mediaUrl && { src: mediaUrl, type: 'video/mp4' }].filter(
          Boolean
        ) as any)
      : ([
          // mpegDashUrl && { src: mpegDashUrl, type: 'application/dash+xml' },
          hlsUrl && { src: hlsUrl, type: 'application/vnd.apple.mpegurl' },
          mediaUrl && { src: mediaUrl, type: 'video/mp4' }
        ].filter(Boolean) as any);

  return {
    id,
    type: VIDEO,
    values: {
      autoPlay: Boolean(autoPlay),
      mediaUrl: mediaUrlData,
      subtitlesUrl: subtitlesUrl || '',
      snapshotUrl: snapshotUrl || ''
    },
    items: []
  };
};

export const BackgroundHelper: ItemHelper<
  'Background',
  BackgroundDefinition
> = src => ({
  id: src.id,
  type: BACKGROUND,
  values: {
    value: src.value || undefined,
    opacity: src.opacity ? (src.opacity as number) : 100,
    isVideo: !!src.videos,
    color: src.color || 'red'
  },
  items: [
    ...(src.pictures || []).map(makeImage),
    ...(src.videos || []).map(makeVideo)
  ].sort((a, b) => (a.position || 0) - (b.position || 0))
});

export const BackgroundHelperWithLogo: ItemHelper<
  'Background',
  BackgroundDefinition
> = src => ({
  id: src.id,
  type: BACKGROUND,
  values: {
    value: src.value || '#FFF',
    opacity: 50,
    isVideo: !!src.videos,
    color: src.color || 'red',
    showLogo: true
  },
  items: []
});
